import { render, staticRenderFns } from "./addCustomer.vue?vue&type=template&id=138442af&scoped=true"
import script from "./addCustomer.vue?vue&type=script&lang=js"
export * from "./addCustomer.vue?vue&type=script&lang=js"
import style0 from "./addCustomer.vue?vue&type=style&index=0&id=138442af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138442af",
  null
  
)

export default component.exports